import { Client, Coach } from "@/types/page";
import { dataLayerUserData } from "@/utils/dataLayerUserData";

type CreatedAccountSource = {
    justRegistered: boolean;
    user: Client | Coach | null;
};

export function trackCreatedAccount({
    justRegistered,
    user,
}: CreatedAccountSource): void {
    if (!justRegistered || !user) {
        return;
    }

    dataLayer.push({
        event: "created_account",
        ...dataLayerUserData(user),
    });
}
